export default __webpack_public_path__ + "connect-3583f40dafc651aba0dd24507a63c558.mp3";